module.exports = "/_next/static/images/notifications-94aa52ed6fb1440aca0ce9bcd5cc4300.png";